import { Row, Col } from 'reactstrap';

const CategoryTile = ({ category, onClick }) => {
  let scoreColour = 'green';
  if (category.score < category?.cards?.length) scoreColour = 'black';
  if (category.score === 0) scoreColour = 'gray';

  return (
    <Col className="text-black m-0 p-0" xs={12} sm={12} md={6} lg={6} xl={4} xxl={3} onClick={() => onClick(category)}>
      <Row className="p-0 m-2 border rounded border-gray" style={{boxShadow: '5px 2px 2px #dddddd', cursor: 'pointer'}}>
        <Col xs={3} sm={3} md={3} className="p-0 m-0 text-center" >
          <img src={category.iconName} alt="" style={{width: '100%', padding: 6}}/>
        </Col>
        <Col xs={6} sm={6} md={6} className="text-center p-2 m-0 bg-lightgray d-flex flex-column justify-content-center" style={{fontSize: 16}}>{category.name}</Col>
        <Col xs={3} sm={3} md={3} className="p-0 text-center d-flex flex-column text-nowrap justify-content-center" >
          <small>SCORE</small>
          <span style={{fontSize: 22}} >{category.score} / {category.cards?.length || 0}</span>
        </Col>
      </Row>
    </Col>
  );
};

export default CategoryTile;
